import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Container } from 'semantic-ui-react'
import styled from 'styled-components'
import CustomIcon from '~/components/CustomIcon'
import { FormFields } from '~/components/FormFields'

interface Props {
  control: any
}

const StyledHeader = styled.div`
font-size: 15px !important;
font-weight: bold;
`

const Perimeters: React.FC<Props> = ({ control }) => {
  const { t } = useTranslation()
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'perimeters',
    keyName: 'key'
  })

  return <Container fluid style={{ marginBottom: '2em', marginTop: '2em' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <StyledHeader>{'Umkreis (in km)'}</StyledHeader>
      <Button
        onClick={() => append({
          perimeter: ''
        })}
        style={{ fontSize: '0.9rem' }}
        basic
        color='green'
        type={'button'}
        icon='plus'
      />
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
      {fields.map((field, index) => {
        return <div key={field.key} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <FormFields.Input
            control={control}
            typeInput={'controled'}
            name={`perimeters[${index}].perimeter`}
            placeholder={t('Please enter perimeter')}
            rules={{
              required: true
            }}
            styleControlled={{ width: 150 }}
            withoutAsterisk
            noErrorMessage
          />
          <CustomIcon
            name='trash'
            color='red'
            size='large'
            style={{ marginBottom: 8 }}
            onClick={() => remove(index)}
          />
        </div>
      })}
    </div>
  </Container>
}
export default Perimeters